<!-- ═══ Console Dialog Chassis ═══ -->
<div class="aad-console">
  <!-- Top Bar -->
  <div class="aad-console__topbar d-flex align-items-center gap-2">
    <span class="aad-console__led aad-console__led--green"></span>
    <span class="aad-console__led aad-console__led--amber"></span>
    <span class="aad-console__led aad-console__led--red"></span>
    <span class="aad-console__topbar-title ms-2">
      {{ 'ADD_ACHIEVEMENT_DIALOG.TITLE' | translate }}
    </span>
    <button
      mat-icon-button
      [tabIndex]="-1"
      type="button"
      class="aad-console__close ms-auto"
      (click)="dialogRef.close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Divider -->
  <div class="aad-console__divider d-flex align-items-center gap-2 my-2">
    <span class="aad-console__divider-line flex-grow-1"></span>
    <span class="aad-console__divider-label">MISSION·ASSIGN</span>
    <span class="aad-console__divider-line flex-grow-1"></span>
  </div>

  <!-- Screen Bezel -->
  <div class="aad-console__bezel">
    <span class="aad-console__screw aad-console__screw--tl"></span>
    <span class="aad-console__screw aad-console__screw--tr"></span>
    <span class="aad-console__screw aad-console__screw--bl"></span>
    <span class="aad-console__screw aad-console__screw--br"></span>

    <div class="aad-console__screen">
      <div class="aad-console__scanlines" aria-hidden="true"></div>

      <div mat-dialog-content class="aad-console__content">
        <mat-horizontal-stepper [linear]="true" #stepper class="aad-stepper">
          <!-- ── Step 1: Select Achievement ── -->
          <mat-step [stepControl]="achievementFormGroup">
            <ng-template matStepLabel>
              {{ 'ADD_ACHIEVEMENT_DIALOG.SELECT_ACHIEVEMENT_STEP.LABEL' | translate }}
            </ng-template>

            <mat-progress-bar
              class="aad-console__progress my-2"
              *ngIf="isLoading"
              mode="indeterminate"
            ></mat-progress-bar>

            <p *ngIf="!achievements.length && !isLoading" class="aad-console__empty-msg text-center py-3">
              {{ 'ADD_ACHIEVEMENT_DIALOG.SELECT_ACHIEVEMENT_STEP.EMPTY_ACHIEVEMENTS' | translate }}
            </p>

            <app-achievements-list
              *ngIf="achievements.length"
              [achievements]="achievements"
              [selective]="true"
              (onAchievementSelect)="selectAchievement($event); stepper.next()"
            ></app-achievements-list>

            <div class="d-flex justify-content-end mt-3">
              <button class="aad-btn aad-btn--primary" matStepperNext>{{ 'BUTTON.NEXT' | translate }} ▶</button>
            </div>
          </mat-step>

          <!-- ── Step 2: Description ── -->
          <mat-step [stepControl]="descriptionFormGroup">
            <form [formGroup]="descriptionFormGroup">
              <ng-template matStepLabel>
                {{ 'ADD_ACHIEVEMENT_DIALOG.DESCRIPTION_STEP.LABEL' | translate }}
              </ng-template>

              <mat-form-field class="w-100 mt-2 aad-field">
                <textarea
                  matInput
                  [placeholder]="'ADD_ACHIEVEMENT_DIALOG.DESCRIPTION_STEP.TEXT_PLACEHOLDER' | translate"
                  formControlName="description"
                  rows="4"
                  required
                ></textarea>
              </mat-form-field>

              <div class="d-flex justify-content-between mt-2">
                <button class="aad-btn aad-btn--ghost" matStepperPrevious>◀ {{ 'BUTTON.BACK' | translate }}</button>
                <button class="aad-btn aad-btn--primary" matStepperNext>{{ 'BUTTON.NEXT' | translate }} ▶</button>
              </div>
            </form>
          </mat-step>

          <!-- ── Step 3: Extra Points ── -->
          <mat-step [stepControl]="extraPointsFormGroup">
            <form [formGroup]="extraPointsFormGroup">
              <ng-template matStepLabel>
                {{ 'ADD_ACHIEVEMENT_DIALOG.EXTRA_POINTS_STEP.LABEL' | translate }}
              </ng-template>

              <mat-form-field class="w-100 mt-2 aad-field">
                <input
                  type="number"
                  min="0"
                  matInput
                  [placeholder]="'ADD_ACHIEVEMENT_DIALOG.EXTRA_POINTS_STEP.TEXT_PLACEHOLDER' | translate"
                  formControlName="extraPoints"
                  required
                />
              </mat-form-field>

              <div class="aad-points-info d-flex align-items-center gap-2 mb-3">
                <span class="aad-points-info__pip"></span>
                <span class="aad-points-info__text">
                  {{
                    'ADD_ACHIEVEMENT_DIALOG.POINTS_REMAINING_THIS_MONTH'
                      | translate: { pointPool: teamMonthlyPointPool, availablePoints: availablePoints }
                  }}
                </span>
              </div>

              <div class="d-flex justify-content-between">
                <button class="aad-btn aad-btn--ghost" matStepperPrevious>◀ {{ 'BUTTON.BACK' | translate }}</button>
                <button class="aad-btn aad-btn--primary" matStepperNext>{{ 'BUTTON.NEXT' | translate }} ▶</button>
              </div>
            </form>
          </mat-step>

          <!-- ── Step 4: Confirm ── -->
          <mat-step class="position-relative">
            <ngx-ui-loader [fgsSize]="25" [loaderId]="loaderId"></ngx-ui-loader>
            <ng-template matStepLabel>
              {{ 'ADD_ACHIEVEMENT_DIALOG.FINISH_STEP.LABEL' | translate }}
            </ng-template>

            <!-- Preview card -->
            <div class="aad-preview row align-items-center justify-content-center g-3 my-2">
              <div class="col-auto">
                <div class="aad-preview__icon-wrap">
                  <span class="aad-preview__screw aad-preview__screw--tl"></span>
                  <span class="aad-preview__screw aad-preview__screw--tr"></span>
                  <span class="aad-preview__screw aad-preview__screw--bl"></span>
                  <span class="aad-preview__screw aad-preview__screw--br"></span>
                  <app-s3-image
                    [image]="achievementForm.achievement.value?.icon"
                    class="aad-preview__icon"
                  ></app-s3-image>
                </div>
              </div>
              <div class="col-auto d-flex flex-column align-items-center">
                <mat-icon class="aad-preview__arrow">arrow_forward</mat-icon>
              </div>
              <div class="col-auto">
                <div class="aad-preview__player">
                  <span class="aad-preview__player-prefix">▶</span>
                  {{ data?.user?.username }}
                </div>
              </div>
            </div>

            <!-- Summary -->
            <div class="aad-summary text-center mb-3">
              <p class="aad-summary__desc mb-1">{{ descriptionForm.description.value }}</p>
              <p class="aad-summary__points mb-0">
                +{{ extraPointsForm.extraPoints.value }}
                {{
                  'ADD_ACHIEVEMENT_DIALOG.FINISH_STEP.PLUS_POINTS'
                    | translate: { value: extraPointsForm.extraPoints.value }
                }}
              </p>
            </div>

            <div class="d-flex flex-wrap justify-content-between gap-2">
              <button class="aad-btn aad-btn--ghost" matStepperPrevious>◀ {{ 'BUTTON.BACK' | translate }}</button>
              <div class="d-flex gap-2">
                <button class="aad-btn aad-btn--ghost" (click)="stepper.reset(); errorMessage = ''">
                  {{ 'BUTTON.RESET' | translate }}
                </button>
                <button class="aad-btn aad-btn--confirm" (click)="onAddAchievement()">
                  ✔ {{ 'BUTTON.ADD' | translate }}
                </button>
              </div>
            </div>
          </mat-step>
        </mat-horizontal-stepper>

        <!-- Error alert -->
        <div
          *ngIf="errorCode || errorMessage"
          class="aad-console__alert d-flex align-items-center gap-2 mt-3"
          [@fadeInOut]
        >
          <span class="aad-console__alert-led"></span>
          <mat-icon class="aad-console__alert-icon">error_outline</mat-icon>
          <span class="aad-console__alert-text">
            {{
              errorCode
                ? ('ADD_ACHIEVEMENT_DIALOG.ERROR_' + errorCode
                  | translate
                    : {
                        points: extraPointsForm.extraPoints.value,
                        availablePoints: availablePoints,
                        teamName: data.user?.team?.name
                      })
                : errorMessage
            }}
          </span>
        </div>
      </div>
      <!-- /.aad-console__content -->
    </div>
    <!-- /.aad-console__screen -->
  </div>
  <!-- /.aad-console__bezel -->

  <!-- Screen footer -->
  <!-- <div class="aad-console__screen-footer d-flex align-items-center justify-content-between px-2 py-1 mt-1">
    <span class="aad-console__footer-label">◀ ▶ NAVIGATE STEPS</span>
    <span class="aad-console__footer-label">● CONFIRM</span>
  </div> -->
</div>
